module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_7005.6b4d314a.png";